// src/api/authApi.ts

import axios from "axios";
import { BASE_URL } from "./client";
import { AdminLoginRequest, AdminLoginResponse } from "../types";

/**
 * Login del panel: acepta usuario o email. El backend valida la contraseña con
 * Firebase y solo deja entrar a cuentas habilitadas con ROLE_ADMIN.
 * Se usa axios directo (sin el interceptor) porque todavía no hay token.
 */
export const loginAdmin = async (payload: AdminLoginRequest) => {
  const res = await axios.post<AdminLoginResponse>(`${BASE_URL}/auth/admin/login`, payload, {
    timeout: 20000,
  });
  return res.data;
};
